import { render, staticRenderFns } from "./hYcostAdd.vue?vue&type=template&id=5fa5d01b&scoped=true&"
import script from "./hYcostAdd.vue?vue&type=script&lang=js&"
export * from "./hYcostAdd.vue?vue&type=script&lang=js&"
import style0 from "./hYcostAdd.vue?vue&type=style&index=0&id=5fa5d01b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa5d01b",
  null
  
)

export default component.exports